import React, { useEffect } from "react";
import { HashRouter as Router, Routes, Route, Navigate, useNavigate } from "react-router-dom";

import Home from "./Pages/Home";
import Login from "./Pages/Login";
import Otp from "./Pages/Otp";

const SAFMRouter = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.localStorage.removeItem("user");
    navigate("/login");
  }, []);

  return <></>;
};

export default function App() {
  return (
    <Router>
      <div>
        <Routes>
          <Route path='/' element={<SAFMRouter />}></Route>
          <Route path='/login' element={<Login />} />
          <Route path='/otp' element={<Otp />} />
          <Route path='/home' element={<Home />} />
        </Routes>
      </div>
    </Router>
  );
}
